<template>
  <div class="dialog-action-buttons">
    <button
      :disabled="disableCancel"
      @click="handleClickCancel"
    >
      {{ cancelLabel }}
    </button>
    <button
      :disabled="isLoading"
      @click="handleClickConfirm"
    >
      <i
        v-show="isLoading"
        class="el-icon-loading"
      />
      {{ confirmLabel }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'DialogActionButtons',
  props: {
    cancelLabel: {
      type: String,
      default: '취소'
    },
    confirmLabel: {
      type: String,
      default: '저장'
    },
    disableCancel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    handleClickCancel() {
      this.$emit('cancel');
    },
    handleClickConfirm() {
      this.isLoading = true;
      this.$emit('confirm');
    },
    stopLoading() {
      setTimeout(() => {
        this.isLoading = false;
      }, 700);
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-action-buttons {
  button {
    height: 60px;
    font-size: 17px;
    color: #4a4a4a;
    letter-spacing: -0.68px;
    text-align: center;
    border: 0;
    background-color: #d3d3d3;
    cursor: pointer;

    &:focus {
      outline: 0;
    }

    &:first-child {
      width: 125px;
      border-bottom-left-radius: 8px;
      background-color: #9b9b9b;
      color: #ffffff;

      &:hover {
        background-color: #919191;
      }

      &:disabled {
        color: #b9b9b9;
        background-color: #d3d3d3;
        border-right: 1px solid #f2f2f2;
      }
    }

    &:last-child {
      width: calc(100% - 125px);
      border-bottom-right-radius: 8px;

      &:hover {
        background-color: #c9c9c9;
      }

      &:disabled {
        cursor: not-allowed;
        color: #696969;
        background-color: #d8d8d8;
      }
    }

    @media screen and (max-width: 768px) {
      button {
        height: 50px;
      }
    }
  }
}
</style>
